export default function Rating({ value, size = "text-sm" }: { value: number; size?: string }) {
  return (
    <span className={`inline-flex items-center gap-0.5 ${size}`} aria-label={`评分 ${value} 分`}>
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = value >= i;
        const half = !filled && value > i - 1;
        return (
          <i
            key={i}
            aria-hidden="true"
            className={`${half ? "ri-star-half-line text-secondary-500" : filled ? "ri-star-fill text-secondary-500" : "ri-star-line text-foreground-300"}`}
          />
        );
      })}
    </span>
  );
}